import React from "react";
import { Box } from "@chakra-ui/react";
import FullCalendarWithModal from "../../components/FullCalendar/FullCalendarWithModal";

export default function CalendarPage() {
  return (
    <Box>
      <Box mt={4}>
        <FullCalendarWithModal />
      </Box>
    </Box>
  );
}
